module.exports = ".go_live_flex {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n.btn_flex {\r\n  display: flex;\r\n}\r\n"